import React from 'react';
import styled from 'styled-components';
import { ReactComponent as Alert } from '../../assets/icons/alert.svg';

export const IncorrectContactRoot = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin: 24px 0 32px 0;

  span {
    margin-left: 16px;
  }
`;

const IncorrectContact: React.FC = () => {
  return (
    <IncorrectContactRoot>
      <Alert />

      <span>
        Se nenhum destes contatos estiver correto, entre em contato diretamente
        com o credor para realizar a atualização dos seus dados cadastrais.
      </span>
    </IncorrectContactRoot>
  );
};

export default IncorrectContact;
